"use client";

import Input from "./Input";
import Field from "./Field";

function Username({
  autoFocus,
  className,
  errorMessage,
  fieldName,
  inputClassName,
  label,
  requiredPlaceholder,
}: {
  autoFocus?: boolean;
  className?: string;
  errorMessage: string;
  fieldName: string;
  inputClassName?: string;
  label: string;
  requiredPlaceholder?: string;
}) {
  return (
    <Field
      className={className}
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          autoComplete="username"
          autoFocus={autoFocus}
          className={inputClassName ?? "w-72"}
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          value={typeof value === "string" ? value : undefined}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{ required: errorMessage }}
      label={label}
    />
  );
}

export default Username;
